import {Tooltip} from '@mui/material'

import React, {ReactNode} from 'react'

import {InputWithLabelWrapper, Label, LabelAndTooltipWrapper, TooltipIcon} from './style'

interface Props {
  label?: string
  width?: number
  tooltip?: string
  children: ReactNode
}

/**
 * Wrapper component with a label used for form fields
 */
export function LabeledWrapper(props: Props) {
  const {label, width, tooltip, children} = props

  return (
    <InputWithLabelWrapper width={width} gap={1}>
      <LabelAndTooltipWrapper>
        {label && <Label>{label}</Label>}
        {tooltip && (
          <Tooltip title={tooltip}>
            <TooltipIcon />
          </Tooltip>
        )}
      </LabelAndTooltipWrapper>
      {children}
    </InputWithLabelWrapper>
  )
}
